import React from 'react';
import classNames from 'classnames/bind';
import { Link } from 'react-router';
import { isEmpty } from 'ramda';

import Avatar from 'app/common/ui/Avatar';
// import Avatar from 'app/components/_ui/Avatar';
import { DotsLoader } from 'app/common/components/Loader';
import Eljurlogo from './svg/eljurlogo.svg';
import styles from './StudentItem.scss';
import CampInfo from './CampInfo';


const cx = classNames.bind(styles);

type Props = {
  id: string,
  gender: string,
  name: {
    first: string,
  },
  photo?: string,
  showBalance: boolean,
  balanceValue: string,
  events: number,
  active: boolean,
  url: string,
  externalId: ?string,
  showExternalLogo: boolean,
  currency: string,
  camp?: boolean,
  camps?: Array<any>
}

const StudentItem = ({
  id,
  gender,
  name,
  photo,
  showBalance,
  balanceValue,
  events,
  active,
  url,
  // externalId,
  showExternalLogo,
  currency,
  camp,
  camps,
}: Props) => (
  camp && isEmpty(camps)
    ? null
    : <Link to={url} className={cx({ root: true, active })}>
      <Avatar src={photo} gender={gender} className={styles.ava} active={active} />

      <div className={styles.name}>{name && name.first}</div>

      {camp && <CampInfo studentId={id} active={active} currency={currency} />}

      {showBalance
        && !camp
        && <div className={cx({ balance: true, negative: balanceValue && parseFloat(balanceValue) < 0 })}>
          {balanceValue || <DotsLoader simple />}
        </div>}

      {!!events && <div className={styles.events}>{events}</div>}

      {showExternalLogo
        && <Eljurlogo className={styles.eljurlogo} />}
    </Link>
);

export default StudentItem;
